import { PageWrapper } from "../../../components/page-skeleton/PageWrapper";
import { useGetAdyenAccountHolder } from "../service/adyen-account-holders-api";
import { Outlet, useParams } from "react-router";
import { SpinnerBlock } from "../../common/Spinner";
import { AdyenAccountHolderInspect } from "./components/AdyenAccountHolderInspect";
import { GoBackLinkButton } from "../../../components/GoBackLinkButton";
import { routes } from "../../../appRoutingHelpers";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { AdyenAccountHolderBusinessLines } from "./components/AdyenAccountHolderBusinessLines";
import { AdyenAccountHolderStores } from "./components/AdyenAccountHolderStores";
import { AdyenAccountHolderBalanceAccounts } from "./components/AdyenAccountHolderBalanceAccounts";
import { AdyenSplitConfigurations } from "./components/AdyenSplitConfigurations";
import { PaymentInstruments } from "./components/PaymentInstruments";

export const AdyenAccountHolderPage = () => {
  const { id } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: accountHolder, isLoading } = useGetAdyenAccountHolder(id);

  return (
    <>
      {isLoading || !accountHolder ? (
        <SpinnerBlock />
      ) : (
        <>
          <PageWrapper>
            <GoBackLinkButton
              to={routes.adyenAccountHolders(organizationKeyName)}
              text="Back to account holders"
            />
            <AdyenAccountHolderInspect accountHolder={accountHolder} />
            <AdyenAccountHolderBusinessLines />
            <AdyenAccountHolderStores />
            <AdyenSplitConfigurations />
            <AdyenAccountHolderBalanceAccounts />
            <PaymentInstruments />
          </PageWrapper>
          <Outlet />
        </>
      )}
    </>
  );
};
